'use client';

import { NavigableButton } from '@carvana/ds-button';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { DispatcherEvent } from '@carvana/merch-native';
import { datadogRum } from '@datadog/browser-rum';
import { type MouseEvent, useContext } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { useIsNative } from '~/context/common/DeviceContext';
import sendMessageToNative from '~/native/flp/dispatchers/sendMessageToNative';

type OwnProps = {
  cvnaid: string;
};

export default function ShopWithYourTermsCta({ cvnaid }: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);
  const isNative = useIsNative();

  function handleClick(ev: MouseEvent<HTMLAnchorElement>) {
    datadogRum.addAction(DATADOG_EVENTS.PREQUALIFIED.CLICKS_HERO_CTA);
    trackEvent(ANALYTICS_EVENTS.PREQUALIFIED.CLICKS_HERO_CTA);

    if (isNative) {
      ev.preventDefault();
      sendMessageToNative(DispatcherEvent.SearchVehicles, { cvnaid });
    }
  }

  return (
    <NavigableButton
      className="w-full"
      data-analytics-id="Financing Shop With Your Terms Button"
      data-native-included={false}
      data-testid="shop-with-your-terms"
      href={`/cars/filters?cvnaid=${cvnaid}&refSource=financing`}
      onClick={handleClick}
    >
      Shop With Your Terms
    </NavigableButton>
  );
}
